<template>
  <div>
    <div class="hero">
      <slot name="hero"></slot>
    </div>
    <slot name="grid-section"></slot>
    <div>
      <slot name="first-row"></slot>
    </div>
    <div class="google-reviews">
      <slot name="google-reviews"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.hero {
  max-width: 100vw;
  overflow-x: hidden;
}
.google-reviews {
  width: 100%;
  padding: 40px 10px;
}
</style>



// WEBPACK FOOTER //
// Industries.vue?7e7a605c